import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/NavBar';
import { getChallengeById, joinChallenge, leaveChallenge, getLeaderboard, deleteChallenge, autoSyncToChallenge, completeChallenge } from '../services/api';
import { Trophy, ArrowLeft, Users, Calendar, Target, Activity, Medal, Trash2, Settings, MoreVertical } from 'lucide-react';
import { DotLoader } from 'react-spinners';
import { useAuth } from '../context/AuthContext';
import MultiplicateurModal from '../components/MultiplicateurModal';
import defaultAvatar from '../assets/default-avatar.jpg'
// Composant Countdown
function Countdown({ endDate }) {
  const [timeLeft, setTimeLeft] = useState({});

  

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(endDate) - new Date();
      
      if (difference > 0) {
        return {
          jours: Math.floor(difference / (1000 * 60 * 60 * 24)),
          heures: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          secondes: Math.floor((difference / 1000) % 60)
        };
      }
      return { termine: true };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [endDate]);

  if (timeLeft.termine) {
  return (
    <div className="relative overflow-hidden text-center py-6 sm:py-8 px-6 sm:px-8 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 border border-slate-700 rounded-xl shadow-2xl">
      {/* Effet de confettis animé */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-2 h-2 bg-indigo-400 rounded-full animate-ping" style={{ animationDelay: '0s' }}></div>
        <div className="absolute top-0 left-1/2 w-2 h-2 bg-indigo-500 rounded-full animate-ping" style={{ animationDelay: '0.2s' }}></div>
        <div className="absolute top-0 left-3/4 w-2 h-2 bg-indigo-400 rounded-full animate-ping" style={{ animationDelay: '0.4s' }}></div>
      </div>
      
      <div className="relative z-10">
        <p className="text-2xl sm:text-4xl font-black bg-gradient-to-r from-indigo-400 via-indigo-500 to-indigo-600 bg-clip-text text-transparent">
          Challenge terminé !
        </p>
        <p className="text-sm sm:text-base text-gray-400 mt-2">Consultez les résultats finaux</p>
      </div>
    </div>
  );
}

return (
  <div className="relative overflow-hidden bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 border-2 border-indigo-500/30 rounded-xl shadow-xl">
    {/* Effet de lueur animée */}
    <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/10 via-indigo-500/10 to-indigo-600/10 animate-pulse"></div>
    
    {/* Barre lumineuse en haut */}
    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent animate-pulse"></div>
    
    <div className="relative z-10 py-4 sm:py-6 px-4 sm:px-6">
      {/* Titre */}
      <div className="text-center mb-3 sm:mb-4">
        <p className="text-xs sm:text-sm font-semibold text-indigo-400 uppercase tracking-wider">Temps restant</p>
      </div>
      
      {/* Timer en un bloc */}
      <div className="flex items-center justify-center gap-1 sm:gap-2 md:gap-3">
        {/* Jours */}
        <div className="flex flex-col items-center transition-all duration-300 hover:scale-105">
          <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent">
            {String(timeLeft.jours || 0).padStart(2, '0')}
          </p>
          <p className="text-[10px] sm:text-xs md:text-sm text-indigo-300 font-medium uppercase tracking-wide mt-0.5 sm:mt-1">
            Jours
          </p>
        </div>

        {/* Séparateur */}
        <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-indigo-500 animate-pulse mb-4 sm:mb-5 md:mb-6">:</span>

        {/* Heures */}
        <div className="flex flex-col items-center transition-all duration-300 hover:scale-105">
          <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent">
            {String(timeLeft.heures || 0).padStart(2, '0')}
          </p>
          <p className="text-[10px] sm:text-xs md:text-sm text-indigo-300 font-medium uppercase tracking-wide mt-0.5 sm:mt-1">
            Heures
          </p>
        </div>

        {/* Séparateur */}
        <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-indigo-500 animate-pulse mb-4 sm:mb-5 md:mb-6">:</span>

        {/* Minutes */}
        <div className="flex flex-col items-center transition-all duration-300 hover:scale-105">
          <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent">
            {String(timeLeft.minutes || 0).padStart(2, '0')}
          </p>
          <p className="text-[10px] sm:text-xs md:text-sm text-indigo-300 font-medium uppercase tracking-wide mt-0.5 sm:mt-1">
            Minutes
          </p>
        </div>

        {/* Séparateur */}
        <span className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-indigo-500 animate-pulse mb-4 sm:mb-5 md:mb-6">:</span>

        {/* Secondes */}
        <div className="flex flex-col items-center transition-all duration-300 hover:scale-105">
          <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent animate-pulse">
            {String(timeLeft.secondes || 0).padStart(2, '0')}
          </p>
          <p className="text-[10px] sm:text-xs md:text-sm text-indigo-300 font-medium uppercase tracking-wide mt-0.5 sm:mt-1">
            Secondes
          </p>
        </div>
      </div>
    </div>
    
    {/* Barre lumineuse en bas */}
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent animate-pulse"></div>
  </div>
);
}

function ChallengePage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [challenge, setChallenge] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [autoSyncing, setAutoSyncing] = useState(false);
  const [showMultiplicateurModal, setShowMultiplicateurModal] = useState(false);
  const [completing, setCompleting] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    fetchChallenge();
    fetchLeaderboard();
  }, [id]);

  

  const fetchChallenge = async () => {
    try {
      const data = await getChallengeById(id);
      setChallenge(data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur:', error);
      setLoading(false);
    }
  };

  const fetchLeaderboard = async () => {
    try {
      const data = await getLeaderboard(id);
      setLeaderboard(data);
    } catch (error) {
      console.error('Erreur leaderboard:', error);
    }
  };

  const handleComplete = async () => {
    if (!window.confirm('⚠️ Terminer le challenge ?\n\nCette action est irréversible et attribuera les points aux participants selon leur classement.')) return;

    setCompleting(true);
    try {
      const result = await completeChallenge(id);
      await fetchChallenge();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    } finally {
      setCompleting(false);
    }
  };

  const handleJoin = async () => {
    try {
      await joinChallenge(id);
      fetchChallenge();
      fetchLeaderboard();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    }
  };

  const handleLeave = async () => {
    if (!window.confirm('Êtes-vous sûr de vouloir quitter ce challenge ?')) return;

    try {
      await leaveChallenge(id);
      navigate(`/club/${challenge.club._id}/challenges`);
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    }
  };

  const handleDelete = async () => {
    // Vérifier si c'est un challenge hebdomadaire (a un parent)
    const isRecurring = challenge?.parentChallenge;
    const message = isRecurring
      ? 'Êtes-vous sûr de vouloir supprimer ce challenge ? Cela supprimera aussi le challenge récurrent (aucun nouveau challenge ne sera généré).'
      : 'Êtes-vous sûr de vouloir supprimer ce challenge ? Cette action est irréversible.';

    if (!window.confirm(message)) return;

    try {
      // Supprimer le challenge
      await deleteChallenge(id);

      // Si c'est un challenge hebdomadaire, supprimer aussi le template parent
      if (isRecurring && challenge.parentChallenge) {
        await deleteChallenge(challenge.parentChallenge);
      }

      navigate(`/club/${challenge.club._id}/challenges`);
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    }
  };

  const handleAutoSync = async () => {
    if (!window.confirm('Voulez-vous synchroniser automatiquement toutes vos activités Strava éligibles pour ce challenge ?')) return;

    setAutoSyncing(true);
    try {
      const result = await autoSyncToChallenge(id);
      alert(`✅ Synchronisation terminée !\n\n${result.added} activités ajoutées\n${result.skipped} activités ignorées`);
      await fetchChallenge();
      await fetchLeaderboard();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de la synchronisation');
    } finally {
      setAutoSyncing(false);
    }
  };

  const isParticipant = () => {
    if (!user || !challenge) return false;
    return challenge.participants.some(p => p.user._id === user._id);
  };

  const isCreator = () => {
    if (!user || !challenge) return false;
    const createurId = typeof challenge.createur === 'object' ? challenge.createur._id : challenge.createur;
    return createurId === user._id;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const getTypeLabel = (type) => {
    const types = {
      'distance_totale': 'Distance totale',
      'nombre_courses': 'Nombre de courses',
      'vitesse_moyenne': 'Vitesse moyenne',
      'denivele_total': 'Dénivelé total'
    };
    return types[type] || type;
  };

  const getMedalIcon = (position) => {
    if (position === 0) return '🥇';
    if (position === 1) return '🥈';
    if (position === 2) return '🥉';
    return null;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950">
        <Navbar />
        <div className="flex items-center justify-center h-64">
          <DotLoader color="#6366f1" />
        </div>
      </div>
    );
  }

  if (!challenge) {
    return (
      <div className="min-h-screen bg-slate-950">
        <Navbar />
        <div className="max-w-4xl mx-auto px-4 py-8">
          <p className="text-center text-gray-400">Challenge non trouvé</p>
        </div>
      </div>
    );
  }

  const myParticipant = challenge.participants.find(p => p.user._id === user?._id);

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <main className="max-w-6xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(`/club/${challenge.club._id}/challenges`)}
          className="flex items-center text-indigo-500 hover:text-indigo-400 font-semibold mb-6 transition"
        >
          <ArrowLeft size={20} className="mr-2" />
          Retour aux challenges
        </button>

        {/* Header */}
        <div className="bg-slate-900 border border-slate-800 rounded-xl shadow-lg p-4 sm:p-6 mb-6 sm:mb-8">
          <div className="text-center max-w-3xl mx-auto">
          {/* Icône */}
          <div className="inline-flex items-center justify-center mb-4 sm:mb-6">
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-yellow-500/20 blur-xl rounded-full animate-pulse"></div>
              
              {/* Icon */}
              <div className="relative bg-gradient-to-br from-yellow-500/20 to-yellow-600/10 p-4 sm:p-5 rounded-2xl border border-yellow-500/30">
                <Trophy size={32} className="text-yellow-500 sm:w-10 sm:h-10 md:w-12 md:h-12" />
              </div>
            </div>
          </div>

          {/* Titre */}
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 sm:mb-4 leading-tight">
            {challenge.nom}
          </h1>

          {/* Description */}
          <p className="text-sm sm:text-base md:text-lg text-gray-400 leading-relaxed max-w-2xl mx-auto">
            {challenge.description}
          </p>

          {/* Ligne de séparation décorative */}
          <div className="flex items-center justify-center gap-3 mt-6 sm:mt-8">
            <div className="h-px w-12 sm:w-16 bg-gradient-to-r from-transparent to-indigo-500"></div>
            <div className="w-1.5 h-1.5 rounded-full bg-indigo-500 animate-pulse"></div>
            <div className="h-px w-12 sm:w-16 bg-gradient-to-l from-transparent to-indigo-500"></div>
          </div>
        </div>

       
          {/* Countdown */}
          <div className="mt-4 sm:mt-6">
            <Countdown endDate={challenge.dateFin} />
          </div>
           {/* Stats */}
          <div className="mt-6 sm:mt-8">
            <div className="flex items-center justify-center gap-3 w-full px-4">
              <div className="flex items-center justify-between w-full max-w-md sm:max-w-lg">
                {/* Type */}
                <div className="flex flex-col items-center gap-2 group">
                  <div className="flex items-center gap-2 text-indigo-400">
                    <Target size={18} className="sm:w-5 sm:h-5 transition-transform group-hover:scale-110" />
                    <span className="text-xs sm:text-sm font-medium uppercase tracking-wider text-gray-400">
                      Type
                    </span>
                  </div>
                  <p className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                    {getTypeLabel(challenge.type)}
                  </p>
                </div>

                {/* Séparateur - centré */}
                

                {/* Participants */}
                <div className="flex flex-col items-center gap-2 group">
                  <div className="flex items-center gap-2 text-indigo-400">
                    <Users size={18} className="sm:w-5 sm:h-5 transition-transform group-hover:scale-110" />
                    <span className="text-xs sm:text-sm font-medium uppercase tracking-wider text-gray-400">
                      Participants
                    </span>
                  </div>
                  <p className="text-lg sm:text-xl md:text-2xl font-bold text-white">
                    {challenge.participants.length}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Boutons d'action */}
          <div className="mt-4 sm:mt-6 flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-3">
            {!isParticipant() ? (
              <button
                onClick={handleJoin}
                className="flex-1 px-4 sm:px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white rounded-lg font-semibold transition shadow-lg shadow-indigo-500/20 text-sm sm:text-base"
              >
                Rejoindre le challenge
              </button>
            ) : (
              <>
                {/* Container flex pour boutons synchroniser + dropdown */}
                <div className="flex flex-1 min-w-full sm:min-w-0 gap-2 sm:gap-3">
                  <button
                    onClick={handleAutoSync}
                    disabled={autoSyncing}
                    className="flex-1 px-4 sm:px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-semibold flex items-center justify-center gap-2 transition disabled:opacity-50 shadow-lg shadow-orange-500/20 text-sm sm:text-base"
                  >
                    {autoSyncing ? (
                      <>
                        <DotLoader size={20} color="white" />
                        <span className="hidden sm:inline">Synchronisation...</span>
                        <span className="sm:hidden">Sync...</span>
                      </>
                    ) : (
                      <>
                        <Activity size={18} className="sm:w-5 sm:h-5" />
                        <span className="hidden sm:inline">Synchroniser</span>
                        <span className="sm:hidden">Synchroniser</span>
                      </>
                    )}
                  </button>

                  {/* Dropdown Menu */}
                  <div className="relative">
                    <button
                      onClick={() => setShowDropdown(!showDropdown)}
                      className="h-full px-3 sm:px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-semibold flex items-center justify-center transition shadow-lg"
                    >
                      <MoreVertical size={20} className="sm:w-5 sm:h-5" />
                    </button>

                    {/* Menu déroulant */}
                    {showDropdown && (
                      <>
                        {/* Overlay pour fermer le menu */}
                        <div 
                          className="fixed inset-0 z-10" 
                          onClick={() => setShowDropdown(false)}
                        />
                        
                        {/* Menu */}
                        <div className="absolute right-0 mt-2 w-56 sm:w-64 bg-gray-800 rounded-lg shadow-xl z-20 overflow-hidden border border-gray-700">
                          {/* Quitter (tous les participants) */}
                          <button
                            onClick={() => {
                              setShowDropdown(false);
                              handleLeave();
                            }}
                            className="w-full px-4 py-3 text-left text-red-400 hover:bg-gray-700 transition flex items-center gap-3 text-sm sm:text-base"
                          >
                            <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            <span>Quitter le challenge</span>
                          </button>

                          {/* Boutons créateur uniquement */}
                          {isCreator() && (
                            <>
                              <div className="border-t border-gray-700" />
                              
                              <button
                                onClick={() => {
                                  setShowDropdown(false);
                                  setShowMultiplicateurModal(true);
                                }}
                                className="w-full px-4 py-3 text-left text-indigo-400 hover:bg-gray-700 transition flex items-center gap-3 text-sm sm:text-base"
                              >
                                <Settings size={20} className="flex-shrink-0" />
                                <span>Multiplicateurs</span>
                              </button>

                              <div className="border-t border-gray-700" />

                              <button
                                onClick={() => {
                                  setShowDropdown(false);
                                  handleDelete();
                                }}
                                className="w-full px-4 py-3 text-left text-red-500 hover:bg-gray-700 transition flex items-center gap-3 text-sm sm:text-base"
                              >
                                <Trash2 size={20} className="flex-shrink-0" />
                                <span>Supprimer le challenge</span>
                              </button>
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>

          
        {/* Ma progression */}
        {myParticipant && (
          <div className="mt-6 sm:mt-8">
            <div className="max-w-3xl mx-auto relative overflow-hidden bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 border-2 border-indigo-500/30 rounded-xl shadow-xl p-6 sm:p-8">
              {/* Effet de lueur */}
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-600/5 via-indigo-500/5 to-indigo-600/5"></div>
              
              {/* Barre lumineuse en haut */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent"></div>
              
              <div className="relative z-10">
                {/* Titre centré avec multiplicateur */}
                <div className="text-center mb-6">
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-3">Ma progression</h3>
                  {myParticipant.multiplicateur !== 1.0 && (
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/50 rounded-full">
                      <span className="text-sm sm:text-base text-purple-300 font-semibold">
                        Multiplicateur: <span className="text-purple-100">x{myParticipant.multiplicateur}</span>
                      </span>
                    </div>
                  )}
                </div>

                {/* Stats */}
                <div className="flex items-center justify-center gap-8 sm:gap-12">
                  {/* Distance réelle */}
                  <div className="flex flex-col items-center gap-2 group">
                    <span className="text-xs sm:text-sm font-medium uppercase tracking-wider text-indigo-400">
                      Distance réelle
                    </span>
                    <p className="text-2xl sm:text-3xl md:text-4xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent transition-transform group-hover:scale-105">
                      {myParticipant.totalDistance.toFixed(1)} <span className="text-lg sm:text-xl md:text-2xl">km</span>
                    </p>
                  </div>

                  {/* Séparateur vertical */}
                  <div className="h-12 sm:h-14 w-px bg-gradient-to-b from-transparent via-indigo-500 to-transparent"></div>

                  {/* Distance ajustée ou Activités */}
                  <div className="flex flex-col items-center gap-2 group">
                    <span className="text-xs sm:text-sm font-medium uppercase tracking-wider text-indigo-400">
                      {myParticipant.multiplicateur !== 1.0 ? 'Distance ajustée' : 'Activités'}
                    </span>
                    <p className="text-2xl sm:text-3xl md:text-4xl font-black bg-gradient-to-b from-white to-indigo-300 bg-clip-text text-transparent transition-transform group-hover:scale-105">
                      {myParticipant.multiplicateur !== 1.0 
                        ? <>{(myParticipant.totalDistance * myParticipant.multiplicateur).toFixed(1)} <span className="text-lg sm:text-xl md:text-2xl">km</span></>
                        : myParticipant.totalActivites
                      }
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Barre lumineuse en bas */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent"></div>
            </div>
          </div>
        )}
        </div>

        {/* Classement */}
        <div className="bg-slate-900 border border-slate-800 rounded-xl shadow-lg p-4 sm:p-6">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 flex items-center gap-2 justify-center">
            <Medal size={20} className="text-yellow-500 sm:w-6 sm:h-6" />
            Classement
          </h2>

          {leaderboard.length === 0 ? (
            <div className="text-center py-8 sm:py-12">
              <Users size={40} className="mx-auto text-slate-700 mb-4 sm:w-12 sm:h-12" />
              <p className="text-sm sm:text-base text-gray-400">Aucun participant pour le moment</p>
            </div>
          ) : (
            <div className="space-y-3 sm:space-y-4 max-w-4xl mx-auto">
  {leaderboard.map((participant, index) => {
    const isFirst = index === 0;
    const isCurrentUser = participant.user._id === user?._id;
    const medal = getMedalIcon(index);
    
    return (
      <div
        key={participant.user._id}
        className={`group relative overflow-hidden rounded-xl transition-all duration-300 ${
          isFirst 
            ? 'bg-gradient-to-br from-yellow-900/30 via-yellow-800/20 to-amber-900/30 border-2 border-yellow-500/50 shadow-xl shadow-yellow-500/20 hover:shadow-yellow-500/40 hover:scale-[1.02]'
            : isCurrentUser
            ? 'bg-gradient-to-br from-indigo-900/30 via-indigo-800/20 to-indigo-900/30 border-2 border-indigo-500/50 hover:border-indigo-400 hover:scale-[1.01]'
            : 'bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800 border-2 border-slate-700/50 hover:border-slate-600 hover:scale-[1.01]'
        }`}
      >
        {/* Effet de brillance pour le premier */}
        {isFirst && (
          <>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-500/10 to-transparent animate-pulse"></div>
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>
            <div className="absolute -top-20 -right-20 w-40 h-40 bg-yellow-500/10 rounded-full blur-3xl animate-pulse"></div>
          </>
        )}

        {/* Barre supérieure pour utilisateur actuel */}
        {isCurrentUser && !isFirst && (
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-indigo-500 to-transparent"></div>
        )}

        <div className="relative z-10 p-3 sm:p-5">
          {/* Mobile: Layout vertical / Desktop: Layout horizontal */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
            
            {/* Première ligne mobile: Position + Photo + Nom */}
            <div className="flex items-center gap-3 sm:gap-5 flex-1 min-w-0">
              {/* Position */}
              <div className={`flex items-center justify-center w-10 sm:w-14 h-10 sm:h-14 flex-shrink-0 ${
                isFirst 
                  ? 'text-3xl sm:text-5xl animate-bounce'
                  : 'text-xl sm:text-3xl font-black text-gray-400'
              }`}>
                {medal || index + 1}
              </div>

              {/* Photo de profil */}
              <div className="relative flex-shrink-0 group/avatar">
                <div className={`absolute inset-0 rounded-full blur-md transition-opacity ${
                  isFirst 
                    ? 'bg-yellow-500/30 animate-pulse'
                    : isCurrentUser 
                    ? 'bg-indigo-500/30 opacity-0 group-hover/avatar:opacity-100'
                    : 'bg-slate-500/20 opacity-0 group-hover/avatar:opacity-100'
                }`}></div>
                
                <img
                  src={participant.user.photoProfil || defaultAvatar}
                  alt={`${participant.user.prenom} ${participant.user.nom}`}
                  className={`relative w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover border-2 transition-all duration-300 ${
                    isFirst
                      ? 'border-yellow-500 ring-4 ring-yellow-500/20 group-hover:ring-yellow-500/40'
                      : isCurrentUser
                      ? 'border-indigo-500 group-hover:ring-2 group-hover:ring-indigo-500/50'
                      : 'border-slate-600 group-hover:border-slate-500'
                  }`}
                />
                
                {/* Badge "Vous" */}
                {isCurrentUser && (
                  <div className="absolute -bottom-1 -right-1 px-1.5 py-0.5 bg-indigo-600 text-white text-[9px] sm:text-[10px] font-bold rounded-full border-2 border-slate-900">
                    VOUS
                  </div>
                )}
              </div>

              {/* Nom + Score (mobile) */}
              <div className="flex-1 min-w-0 flex items-center justify-between sm:block">
                <p className={`font-bold truncate ${
                  isFirst 
                    ? 'text-sm sm:text-lg text-yellow-100'
                    : 'text-sm sm:text-base text-white'
                }`}>
                  {participant.user.prenom} {participant.user.nom}
                </p>
                
                {/* Score (visible seulement mobile) */}
                <div className="sm:hidden text-right">
                  {challenge.type === 'distance_totale' && participant.multiplicateur !== 1.0 ? (
                    <p className={`font-black ${
                      isFirst 
                        ? 'text-xl bg-gradient-to-b from-yellow-200 to-yellow-500 bg-clip-text text-transparent'
                        : 'text-lg text-white'
                    }`}>
                      {participant.valeur.toFixed(1)} <span className="text-sm">km</span>
                    </p>
                  ) : (
                    <p className={`font-black ${
                      isFirst 
                        ? 'text-xl bg-gradient-to-b from-yellow-200 to-yellow-500 bg-clip-text text-transparent'
                        : 'text-lg text-white'
                    }`}>
                      {challenge.type === 'vitesse_moyenne'
                        ? `${participant.valeur.toFixed(2)}`
                        : `${participant.valeur.toFixed(1)}`
                      }
                      <span className="text-xs ml-0.5">
                        {challenge.type === 'vitesse_moyenne' ? 'min/km' : challenge.objectif.unite}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Score (visible seulement desktop) */}
            <div className="hidden sm:block text-right flex-shrink-0">
              {challenge.type === 'distance_totale' && participant.multiplicateur !== 1.0 ? (
                <div>
                  <p className={`font-black ${
                    isFirst 
                      ? 'text-2xl sm:text-3xl bg-gradient-to-b from-yellow-200 to-yellow-500 bg-clip-text text-transparent'
                      : 'text-xl sm:text-2xl text-white'
                  }`}>
                    {participant.valeur.toFixed(1)} <span className="text-base sm:text-lg">km</span>
                  </p>
                  <p className="text-[10px] sm:text-xs text-gray-500">
                    ({participant.valeurReelle.toFixed(1)} km réels)
                  </p>
                </div>
              ) : (
                <p className={`font-black ${
                  isFirst 
                    ? 'text-2xl sm:text-3xl bg-gradient-to-b from-yellow-200 to-yellow-500 bg-clip-text text-transparent'
                    : 'text-xl sm:text-2xl text-white'
                }`}>
                  {challenge.type === 'vitesse_moyenne'
                    ? `${participant.valeur.toFixed(2)} min/km`
                    : `${participant.valeur.toFixed(1)} ${challenge.objectif.unite}`
                  }
                </p>
              )}
            </div>
          </div>

          {/* Deuxième ligne: Badges (activités, Strava, multiplicateur) */}
          <div className="flex items-center gap-2 mt-2 ml-[52px] sm:ml-[88px]">
            {/* Activités avec icône */}
            <div className="inline-flex items-center gap-1 text-[10px] sm:text-xs text-gray-400">
              <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
                <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"/>
              </svg>
              <span>{participant.activites}</span>
            </div>
            
            {/* Séparateur */}
            {(participant.hasStrava || participant.multiplicateur !== 1.0) && (
              <span className="text-gray-600">•</span>
            )}
            
            {/* Badge Strava simplifié */}
            {participant.hasStrava && (
              <div className="inline-flex items-center gap-1 text-[10px] sm:text-xs text-orange-400 font-medium">
                <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169"/>
                </svg>
                <span>Strava</span>
              </div>
            )}
            
            {/* Séparateur */}
            {participant.hasStrava && participant.multiplicateur !== 1.0 && (
              <span className="text-gray-600">•</span>
            )}
            
            {/* Multiplicateur simplifié */}
            {participant.multiplicateur !== 1.0 && (
              <div className="inline-flex items-center gap-1 text-[10px] sm:text-xs text-purple-400 font-semibold">
                <svg className="w-3 h-3 sm:w-3.5 sm:h-3.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd"/>
                </svg>
                <span>x{participant.multiplicateur}</span>
              </div>
            )}
          </div>
        </div>

        {/* Barre inférieure décorative */}
        {isFirst && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-yellow-500 to-transparent"></div>
        )}
      </div>
    );
  })}
</div>
          )}
        </div>
      </main>
      
      {/* Modal */}
      {showMultiplicateurModal && (
        <MultiplicateurModal
          challenge={challenge}
          onClose={() => setShowMultiplicateurModal(false)}
          onUpdate={() => {
            fetchChallenge();
            fetchLeaderboard();
          }}
        />
      )}
    </div>
  );
}

export default ChallengePage;